/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Crop_FullInputs */



/**
* | output |
* | --- |
* | "Full Frame" |
*
* @param {Ocr_Crop_FullInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_crop_full = /** @type {((inputs?: Ocr_Crop_FullInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Crop_FullInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Plein cadre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vollbild")
	if (locale === "it") return /** @type {LocalizedString} */ ("Full Frame")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Полнокадровый")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cuadro completo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("全画幅")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フルフレーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूर्ण फ्रेम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Quadro completo")
	return /** @type {LocalizedString} */ ("Full Frame")
});